import { GoogleLoginButton } from 'infrastructure/googleDrive'
import * as React from 'react'
import { FunctionComponent } from 'react'

export function GDriveLogin({
  LoggedInComponent = () => null,
}: {
  LoggedInComponent?: FunctionComponent
}) {
  return (
    <GoogleLoginButton
      hideWhenLoggedIn={true}
      ParentComponent={({ children }) => {
        return (
          <div className="App">
            <p>
              <strong>First</strong>, log in with you google Kiddom account
            </p>
            {children}
          </div>
        )
      }}
      LoggedInComponent={({ user }) => {
        return (
          <div>
            <h3>Logged In!</h3>
            <p>
              <strong>User:</strong> {user.email}
            </p>
            <LoggedInComponent />
          </div>
        )
      }}
    />
  )
}
